import React from 'react';
import { Container, Paper, Toolbar, Tabs, Tab, Box } from '@mui/material';
import { Routes, Route, Outlet, useParams, Navigate } from 'react-router-dom';

import Offers from './offers';
import Offer, { OfferLatest } from './offer';
import { OfferCreate } from './newoffer';
import PdfOfferImportPage from './pdf-import';
import { EOfferSource } from '__generated__/graphql';
import OverflowsList from './overflows';
import ReportPage from './reports_page';
import CancelSEMOffer, { CancelSEMOfferLatest } from './cancel';

function OfferLatestRoute() {
  const { id } = useParams();
  return <OfferLatest id={parseInt(id!)} />;
}

function OfferRoute() {
  const { id, versionId } = useParams();
  return <Offer id={parseInt(id!)} versionId={parseInt(versionId!)} />;
}

function CancelSEMOfferLatestRoute() {
  const { id } = useParams();
  return <CancelSEMOfferLatest id={parseInt(id!)} />;
}

function CancelSEMOfferRoute() {
  const { id, versionId } = useParams();
  return <CancelSEMOffer id={parseInt(id!)} versionId={parseInt(versionId!)} />;
}

export default function OffersIndex() {
  return (
    <>
      <Toolbar />
      <Container maxWidth="xl">
        <Paper>
          <Box p={2}>
            <Routes>
              <Route path="widget" element={<Offers offerSource={EOfferSource.WIDGET} />} />
              <Route path="lister" element={<Offers offerSource={EOfferSource.LISTER} />} />
              <Route path="reports" element={<ReportPage />} />
              <Route path="overflows" element={<OverflowsList />} />
              <Route path="cancelsem/:id" Component={CancelSEMOfferLatestRoute} />
              <Route path="cancelsem/:id/:versionId" Component={CancelSEMOfferRoute} />
              <Route path="_create_widget" element={<OfferCreate offerSource={EOfferSource.WIDGET} />} />
              <Route path="_create_lister" element={<OfferCreate offerSource={EOfferSource.LISTER} />} />
              <Route path="pdf-import" element={<PdfOfferImportPage />} />
              <Route path="pdf-import/:importId" element={<PdfOfferImportPage />} />
              <Route path=":id" Component={OfferLatestRoute} />
              <Route path=":id/:versionId" Component={OfferRoute} />
              <Route path="*" element={<Navigate to="lister" replace />} />
            </Routes>

            <Outlet />
          </Box>
        </Paper>
      </Container>
    </>
  );
}
